/* Jquery match height */
$('.footer-list').matchHeight();
// $('.card').matchHeight();
// $('.home-card').matchHeight();
$('.gallery-image-description').matchHeight();
$('.sponsor').matchHeight();
